/**
 * Countdown for the launch hero section.
 *
 * The theme already ships <countdown-timer>, but it prints single digits ("6") where this
 * design calls for zero-padded pairs ("06"), and it hides itself behind `initLazyScript` —
 * a hero timer needs to be correct on first paint. So this is its own element rather than a
 * change to the shared one, which the rest of the theme relies on.
 */
if (!customElements.get('launch-hero-countdown')) {
  class LaunchHeroCountdown extends HTMLElement {
    connectedCallback() {
      this.endDate = new Date(this.dataset.endDate).getTime();

      // No date set yet (or an unparseable one): leave the markup's placeholder values alone
      // so the section still reads as a countdown in the editor.
      if (!this.endDate) return;

      this.parts = {
        days: this.querySelector('[data-countdown-days]'),
        hours: this.querySelector('[data-countdown-hours]'),
        minutes: this.querySelector('[data-countdown-minutes]'),
        seconds: this.querySelector('[data-countdown-seconds]')
      };

      this.tick();
      this.interval = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const remaining = this.endDate - Date.now();

      if (remaining <= 0) {
        clearInterval(this.interval);
        this.write(0, 0, 0, 0);
        this.setAttribute('data-ended', '');
        if (this.hasAttribute('data-hide-on-end')) this.hidden = true;
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);

      this.write(
        Math.floor(totalSeconds / 86400),
        Math.floor(totalSeconds / 3600) % 24,
        Math.floor(totalSeconds / 60) % 60,
        totalSeconds % 60
      );
    }

    write(days, hours, minutes, seconds) {
      // Days can outgrow two digits on a long pre-order, so only pad — never truncate.
      this.set(this.parts.days, days);
      this.set(this.parts.hours, hours);
      this.set(this.parts.minutes, minutes);
      this.set(this.parts.seconds, seconds);
    }

    set(element, value) {
      if (!element) return;
      const text = String(value).padStart(2, '0');
      if (element.textContent !== text) element.textContent = text;
    }
  }

  customElements.define('launch-hero-countdown', LaunchHeroCountdown);
}
